var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.72112,
    y1: 1.27909,
    x2: 14.7013,
    y2: 14.2593,
    stroke: "#EFEFEF",
    strokeWidth: 2.03964
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.29841,
    y1: 14.2591,
    x2: 14.2786,
    y2: 1.27889,
    stroke: "#EFEFEF",
    strokeWidth: 2.03964
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.14667be8c8c55bb0be48172a01b5b3bd.svg";
export { ForwardRef as ReactComponent };